class LayoutGroupComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { LayoutGroupComponentData };
